/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

import { medliTermConversions } from './medliTerm';

function description(healthEntryCategoryState, languageCode) {
  healthEntryCategoryState.description = healthEntryCategoryState.description || { id: '', strings: [] };

  return {
    get: () => healthEntryCategoryState.description,
    convertToSearchTerm: () => ({
      id: healthEntryCategoryState.description.id,
      string: healthEntryCategoryState.description.strings[languageCode],
    }),
    replaceWithSearchTerm: (medliSearchTerm) => {
      healthEntryCategoryState.description = medliTermConversions.convertSearchTermToTerm(medliSearchTerm, languageCode);
    },
    formattedTermName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(healthEntryCategoryState, 'description.strings', {})[code];
    },
    canonicalName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(healthEntryCategoryState, 'description.canonical_strings', {})[code] || '';
    },
    set: (medliData) => { healthEntryCategoryState.description = medliData; },
    hasDescription: () => healthEntryCategoryState.description.id !== '',
    remove: () => { healthEntryCategoryState.description = { id: '', strings: [] }; },
  };
}

export function cleanDescription(healthEntryValueState) {
  if (_.get(healthEntryValueState, 'description.id', '') === '') {
    healthEntryValueState = _.omit(healthEntryValueState, ['description']);
  }
  return healthEntryValueState;
}

export default description;
